<template lang="html">

  <div class="finca-view sala-de-azafran">

    <section class="full-view-intro column-center banner-intro brown animation" data="sala-de-azafran">

      <h1 class="title -intro">{{$t('vistas.sala_azafran')}}</h1>

      <h2 class="subtitle-intro">{{$t('vistas.la_finca')}}</h2>

    </section>

    <section class="new-texto-imagen row-center ais animation">

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.sala_azafran.cuadro_uno.titulo')}}</h2>
            <p v-html="$t('la_tierra.sala_azafran.cuadro_uno.texto')"></p>
      </div>
      <div class="contenedor-imagen">
         <img src="/static/img/sala-de-azafran/cosecha.jpg" alt="">
      </div>

    </section>

    
    <section class="new-texto-imagen -inverse row-center ais animation">

      <div class="contenedor-imagen">
       <img src="/static/img/sala-de-azafran/sala-de-azafran.jpg" alt="">
     </div>

     <div class="textos column-center">
      <h2 class="title">
        {{$t('la_tierra.sala_azafran.cuadro_dos.titulo')}}
      </h2>
           <p v-html="$t('la_tierra.sala_azafran.cuadro_dos.texto')"></p>
      
    </div>

  </section>




  <section class="imagen-full-texto row-start animation" data="el-proceso" id="sala-del-azafran">

    <div class="contenedor-texto column-start">
      <h2 class="title">{{$t('la_tierra.sala_azafran.proceso.titulo')}}</h2>
      <p>{{$t('la_tierra.sala_azafran.proceso.cuerpo')}}</p>
      <router-link :to="$t('enlaces.proceso_azafran')" class="btn -proceso">
        <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
      </router-link>
    </div>

    <div class="enlace-proceso">

      <router-link :to="$t('enlaces.proceso_azafran')" class="btn-container">

        <span class="btn">
          <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
        </span>

      </router-link>

    </div>

  </section>


  <section class="middle-texto-imagen animation row-center ais">


    <div class="texto column-center">

      <div class="container -half">

        <h2 class="title">{{$t('la_tierra.sala_azafran.sala.titulo')}}</h2>

        <p>{{$t('la_tierra.sala_azafran.sala.cuerpo')}}</p>

      </div>

    </div>

    <div class="contenedor-imagen">
      <div class="imagen" data="sala"></div>
    </div>

  </section>

  <donde-estamos></donde-estamos>

  <otros-lugares></otros-lugares>

          <productos-banner></productos-banner>


</div>

</template>

<script lang="js">

  import bannerContacto from '@/components/parts/banner-contacto';
  import otrosLugares from '@/components/parts/otros-lugares';

  import dondeEstamos from '@/components/parts/donde-estamos';

    import productosBanner from '@/components/parts/productos-banner'

  export default  {
    name: 'sala-de-azafran',
    components : {
      'banner-contacto' : bannerContacto,
      'otros-lugares' : otrosLugares,
      'donde-estamos' : dondeEstamos,
      'productos-banner': productosBanner,
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .full-view-intro{
    background: url("/static/img/sala-de-azafran/background-intro.jpg") center/cover no-repeat;
  }

  .texto-imagen .imagen{
    max-width: 890px;
  }

  .imagen-full-texto[data="el-proceso"]{
    background: url("/static/img/sala-de-azafran/el-proceso.jpg") center/cover no-repeat;
  }



  .imagen[data="sala"]{
   background: url("/static/img/sala-de-azafran/sala.jpg") center/cover no-repeat; 
 }

 .texto-imagen{
  min-height: 480px;
}

@media screen and (max-width: 1200px){
  .imagen-texto{
    padding-top: 100px;
    padding-bottom: 0px;
    .textos{
      max-width: 50%;
      padding-left: 20px;
    }
  }
}

@media screen and (max-width:1023px){
  .texto-imagen{
    padding-top: 100px;
    .contenedor-imagen{
      width: 60vw;
      .imagen{
        width: 100%;
        height: auto;
      }
    }
  }
}

@media screen and (max-width:767px){
  .texto-imagen{
    padding-top: 0px;
    .contenedor-imagen{
      width: 100%;
      padding: 0 0px;
      .imagen{
        width: 100%;
        height: auto;
      }
    }
  }

  .imagen-texto{
    padding-bottom: 50px;    
    .textos{

      max-width: 100%;
      padding-left: 0px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/sala-de-azafran/sala-de-azafran.vue